import { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

export default function UpdateBanner() {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handleUpdate = (e) => {
      setRegistration(e.detail);
      setShowUpdate(true);
    };
    window.addEventListener('sw-update-available', handleUpdate);
    return () => window.removeEventListener('sw-update-available', handleUpdate);
  }, []);

  const handleRefresh = () => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  if (!showUpdate) return null;

  return (
    <div className="fixed top-4 left-4 right-4 z-[200] mx-auto max-w-sm animate-in slide-in-from-top-4 duration-300" data-testid="update-banner">
      <div className="bg-[#5b7f95] text-white rounded-2xl shadow-2xl px-5 py-4 flex items-center gap-3">
        <RefreshCw className="w-5 h-5 flex-shrink-0 animate-spin-slow" />
        <div className="flex-1">
          <p className="font-medium text-sm">New version available!</p>
          <p className="text-xs text-white/70">Tap refresh to update</p>
        </div>
        <button
          onClick={handleRefresh}
          className="px-4 py-2 bg-white text-[#5b7f95] font-semibold text-sm rounded-full hover:bg-gray-100 transition-colors"
          data-testid="update-refresh-btn"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
